<div class="serviceCard">
  <div class="row" style="align-items: center;flex-wrap: nowrap">
    <img [src]="data.icon" alt="{{data.title}}">
    <p class="serviceTitle">{{ data.title | translate}}</p>
  </div>
  <ng-template
    [ngIf]="showMore && data.description.length > 30"
  >
    <p class="serviceDescription">{{data.description  | translate | truncate:[140, '...'] }} <span
      class="more_btn"
      (click)="openMore()"
      [style.right]="_translate?.currentLang === 'ar' ? 'auto' : '10px'"
      [style.left]="_translate?.currentLang === 'en' ? 'auto' : '10px'"
    >{{'COMMON.MORE'| translate}}</span></p>
    <div>

    </div>
  </ng-template>
  <ng-template
    [ngIf]="showMore && data.description.length <=30"
  >
    <p class="serviceDescription">{{data.description  | translate | truncate:[140, '...'] }} <span
      class="more_btn"
      (click)="openMore()"
      [style.right]="_translate?.currentLang === 'ar' ? 'auto' : '10px'"
      [style.left]="_translate?.currentLang === 'en' ? 'auto' : '10px'"
    >{{'COMMON.MORE'| translate}}</span></p>
    <div>

    </div>
  </ng-template>
  <ng-template
    [ngIf]="!showMore && data.description.length < 40"
  >
    <p class="serviceDescription">{{data.description  | translate}}</p>
  </ng-template>
  <ng-template
    [ngIf]="!showMore && data.description.length > 40"
  >
    <p class="serviceDescription">{{data.description  | translate | truncate:[300, '...'] }} <span
      class="more_btn"
      (click)="openMore()"
      [style.right]="_translate?.currentLang === 'ar' ? 'auto' : '10px'"
      [style.left]="_translate?.currentLang === 'en' ? 'auto' : '10px'"
    >{{'COMMON.MORE'| translate}}</span></p>
  </ng-template>
</div>
